import {ICON_TYPES} from '../constants';

export const School = () => {
  return (
    <svg
      width='22'
      height='21'
      viewBox='0 0 22 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_13193_23268)'>
        <path
          d='M18.7083 5.25H12.9456L11.9315 4.23588L15.2083 2.1875L11.7083 0H9.95834V4.01275L8.72109 5.25H2.95834C2.26215 5.25 1.59447 5.52656 1.10219 6.01884C0.609905 6.51113 0.333344 7.17881 0.333344 7.875L0.333344 21H21.3333V7.875C21.3333 7.17881 21.0568 6.51113 20.5645 6.01884C20.0722 5.52656 19.4045 5.25 18.7083 5.25ZM18.7083 7C18.9404 7 19.163 7.09219 19.3271 7.25628C19.4912 7.42038 19.5833 7.64294 19.5833 7.875V8.75H16.4456L14.6956 7H18.7083ZM2.95834 7H6.97109L5.22109 8.75H2.08334V7.875C2.08334 7.64294 2.17553 7.42038 2.33963 7.25628C2.50372 7.09219 2.72628 7 2.95834 7ZM11.7083 19.25H9.95834V16.625C9.95834 16.3929 10.0505 16.1704 10.2146 16.0063C10.3787 15.8422 10.6013 15.75 10.8333 15.75C11.0654 15.75 11.288 15.8422 11.4521 16.0063C11.6162 16.1704 11.7083 16.3929 11.7083 16.625V19.25ZM13.4583 19.25V16.625C13.4583 15.9288 13.1818 15.2611 12.6895 14.7688C12.1972 14.2766 11.5295 14 10.8333 14C10.1371 14 9.46947 14.2766 8.97719 14.7688C8.48491 15.2611 8.20834 15.9288 8.20834 16.625V19.25H2.08334V10.5H5.94559L10.8333 5.61225L15.7211 10.5H19.5833V19.25H13.4583ZM3.83334 12.25H6.45834V14H3.83334V12.25ZM3.83334 15.75H6.45834V17.5H3.83334V15.75ZM15.2083 12.25H17.8333V14H15.2083V12.25ZM15.2083 15.75H17.8333V17.5H15.2083V15.75ZM12.5833 10.5C12.5833 10.8461 12.4807 11.1845 12.2884 11.4722C12.0961 11.76 11.8228 11.9843 11.503 12.1168C11.1833 12.2492 10.8314 12.2839 10.4919 12.2164C10.1525 12.1489 9.84065 11.9822 9.59591 11.7374C9.35116 11.4927 9.18449 11.1809 9.11697 10.8414C9.04945 10.5019 9.0841 10.1501 9.21655 9.8303C9.34901 9.51053 9.57331 9.23722 9.8611 9.04493C10.1489 8.85264 10.4872 8.75 10.8333 8.75C11.2975 8.75 11.7426 8.93437 12.0708 9.26256C12.399 9.59075 12.5833 10.0359 12.5833 10.5Z'
          fill='#43494F'
        />
      </g>
      <defs>
        <clipPath id='clip0_13193_23268'>
          <rect
            width='21'
            height='21'
            fill='white'
            transform='translate(0.333344)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

School.iconType = ICON_TYPES.SCHOOL;
